import type { DashboardWidget, ResolvedWidgetValue } from "../../types";
import { normalizeStateMappings } from "../../stateMappings";
import { HeroCard, HeroMeaning } from "./HeroCard";
import { describeSignalDiagnostic } from "./diagnosticMeaning";
import { formatWidgetRelative } from "./format";
import { describeQuality, effectiveQuality } from "./quality";
import "./stateValue.css";

export function StateValueWidget({ widget, value, editable, onConfigure }: {
  widget: DashboardWidget;
  value: ResolvedWidgetValue;
  editable?: boolean;
  onConfigure?: () => void;
}) {
  const quality = effectiveQuality(value);
  const diagnosed = describeSignalDiagnostic(value.diagnostic);
  const available = !diagnosed && quality === "live" && value.isAvailable &&
    value.numericValue !== null && Number.isFinite(value.numericValue);
  const declaredState = widget.settings.signalKind === "state";
  const mappings = normalizeStateMappings(widget.settings.stateMappings);
  // Igualdade exata: 0,4 nao e codigo 0. `s` do MB nunca entra nesta leitura.
  const mapped = available && declaredState
    ? mappings?.find((entry) => entry.value === value.numericValue)
    : undefined;
  const text = !available ? "--" : mapped?.label ?? "Código não mapeado";
  const tone = !available ? (quality === "stale" ? "warn" : diagnosed?.tone ?? "muted")
    : !declaredState || !mapped ? "warn" : mapped.tone;
  const meaning = !available
    ? quality !== "live" ? describeQuality(quality).title : diagnosed?.text ?? "Sem leitura"
    : !declaredState ? "O sinal atual não está declarado como estado"
      : !mapped ? "Configure o texto e a cor deste código" : null;
  return (
    <HeroCard
      className="w-state"
      title={widget.title}
      caption="Estado declarado pelo equipamento"
      tone={tone === "danger" ? "danger" : tone === "warn" ? "warn" : "ok"}
      alarm={widget.settings.alarmEnabled}
      editable={editable}
      onConfigure={onConfigure}
      footnote={value.measuredAt
        ? `${available ? "Atualizado" : "Última leitura"} ${formatWidgetRelative(value.measuredAt) ?? "agora"}`
        : null}
    >
      <div className="w-state__readout" data-tone={tone}>
        <span className="w-state__dot" aria-hidden="true" />
        <span className="w-state__label">{text}</span>
      </div>
      {available ? <span className="w-state__code">Código recebido: {String(value.numericValue)}</span> : null}
      {meaning ? <HeroMeaning tone={tone === "danger" ? "danger" : tone === "warn" ? "warn" : "muted"}>{meaning}</HeroMeaning> : null}
    </HeroCard>
  );
}
